"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resizeIframe = exports.resizeIFrameToFitContent = exports.getIframeId = exports.getIframeElement = exports.getIframeAttributes = exports.attachIframeEvents = void 0;

var _config = require("./config");

var _partners = require("./partners");

var _document = require("./document");

var _postMessage = require("./postMessage");

var _referrer = require("./referrer");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getInitialHeight = function getInitialHeight(pill) {
  var consumer = pill.dataset.consumer;

  if (_partners.partners[consumer]) {
    return _partners.partners[consumer].height;
  }

  return _config.MIN_HEIGHT;
};

var resizeIFrameToFitContent = function resizeIFrameToFitContent(iFrame) {
  var iFrameHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var minHeight = arguments.length > 2 ? arguments[2] : undefined;
  // eslint-disable-next-line no-param-reassign
  iFrame.height = Math.max(minHeight, iFrameHeight);
};

exports.resizeIFrameToFitContent = resizeIFrameToFitContent;

var resizeIframe = function resizeIframe(iFramePillId, iFrameHeight) {
  var selector = iFramePillId ? "iframe#".concat(_config.IFRAME_ID_PREFIX).concat(iFramePillId) : 'iframe.finect-pill';
  var iframes = document.querySelectorAll(selector); // eslint-disable-next-line no-underscore-dangle

  var pill = window.__finect_pills.pills.find(function (item) {
    return item.pill.pillId === iFramePillId;
  });

  if (!pill) {
    return;
  } // const minHeight = pill && pill.pill.iframeCustomAttributes.height ? pill.pill.iframeCustomAttributes.height : MIN_HEIGHT;
  // const minHeight = MIN_HEIGHT;


  var height = getInitialHeight(pill.pill);
  iframes.forEach(function (currentIframe) {
    height && resizeIFrameToFitContent(currentIframe, iFrameHeight, height);
  });
};

exports.resizeIframe = resizeIframe;

var attachIframeEvents = function attachIframeEvents() {
  var minHeight = _config.MIN_HEIGHT;
  (0, _document.eventListener)(function (postMessage) {
    // Legacy framework
    var data = (0, _postMessage.processPostMessage)(postMessage);

    if (!data) {
      return;
    } // eslint-disable-next-line no-underscore-dangle


    window.__finect_pills.messages.push(data); // Framework 2


    if (data.version === 2) {
      if (data.method) {
        switch (data.method.toLowerCase()) {
          case 'resize':
            resizeIframe(data.pillId, data.height);
            break;

          default: // Do nothing

        }
      }
    } // Framework 1


    if (data.version === 1) {
      switch (data.method) {
        case 'documentHeight':
          {
            var h = parseInt(data.documentHeight, 10);

            if (h < _config.MIN_HEIGHT) {
              h = minHeight;
            } // add a bit of extra space for the border


            h = parseInt(h, 10) + 0;
            var list = document.getElementsByTagName('IFRAME');
            var len = list.length;

            for (var i = 0; i < len; i++) {
              var ifrmSRC = list[i].getAttribute('src');

              if (ifrmSRC) {
                if (ifrmSRC.indexOf('/pill') > 0) {
                  ifrmSRC = ifrmSRC.substring(0, ifrmSRC.indexOf('/pill'));
                }

                if (data.pillUrl.indexOf('/pill') > 0) {
                  data.pillUrl = data.pillUrl.substring(0, data.pillUrl.indexOf('/pill'));
                }

                if (data.pillUrl === ifrmSRC) {
                  list[i].height = "".concat(h, "px");
                }
              }
            }

            break;
          }
        // eslint-disable-next-line no-empty

        default:
          {}
      }
    }
  }); // eslint-disable-next-line no-underscore-dangle

  window.__finect_pills.events = 'attached';
};

exports.attachIframeEvents = attachIframeEvents;

var getIframeId = function getIframeId(pillId) {
  return _config.IFRAME_ID_PREFIX + pillId;
};

exports.getIframeId = getIframeId;

var getIframeAttributes = function getIframeAttributes(pillUrl, pillId, iframeCustomAttributes) {
  return _objectSpread({
    src: pillUrl,
    id: getIframeId(pillId),
    pillbuilderVersion: _config.PILLBUILDER_VERSION,
    "class": _config.IFRAME_CLASS,
    style: 'width:100%;margin-top:10px;margin-bottom:10px;border-radius: 8px;box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;border: 0px;'
  }, iframeCustomAttributes);
};

exports.getIframeAttributes = getIframeAttributes;

var getIframeElement = function getIframeElement(iframeAttributes, pill) {
  // Crea nodo de tipo iframe
  var iframe = document.createElement('iframe'); // const height = pill && pill.iframeParams && pill.iframeParams.height ? pill.iframeParams.height : MIN_HEIGHT;
  // const height = MIN_HEIGHT;

  var height = getInitialHeight(pill);

  var newIframeAttributes = _objectSpread(_objectSpread({}, iframeAttributes), {
    src: (0, _referrer.getPillUrlWithReferrer)(iframeAttributes.src, pill.referrer)
  });

  iframe.setAttribute('height', height);
  Object.entries(newIframeAttributes).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    iframe.setAttribute(key, value);
  });
  return iframe;
};

exports.getIframeElement = getIframeElement;